import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type AppIconSize = 'sm' | 'md' | 'lg';

const SIZES: Record<AppIconSize, { box: string; px: number }> = {
  sm: { box: 'size-6 rounded-md', px: 24 },
  md: { box: 'size-11 rounded-xl', px: 44 },
  lg: { box: 'size-14 rounded-2xl', px: 56 },
};

/**
 * Icona di un modulo (FR-055): tessera gialla con l'iniziale nera e il triangolo del marchio.
 * La B è riservata alla piattaforma, la C è Calcestruzzo. Con `muted` la tessera è neutra, per
 * le App non ancora disponibili.
 */
@Component({
  selector: 'bs-app-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'inline-flex shrink-0' },
  template: `
    <span [class]="boxClass()" [attr.aria-hidden]="label() ? null : 'true'">
      <svg
        [attr.width]="px()"
        [attr.height]="px()"
        viewBox="0 0 64 64"
        [attr.role]="label() ? 'img' : null"
        [attr.aria-label]="label()"
        focusable="false"
      >
        <text
          x="14"
          y="50"
          font-family="Barlow Condensed, Arial Narrow, sans-serif"
          font-weight="800"
          font-size="50"
          [class]="glyphClass()"
        >
          {{ letter() }}
        </text>
        <path d="M42 50L51 41V50Z" [class]="glyphClass()" />
      </svg>
    </span>
  `,
})
export class AppIconComponent {
  /** Codice del modulo, una lettera maiuscola. */
  readonly code = input.required<string>();
  readonly size = input<AppIconSize>('md');
  readonly muted = input(false);
  /** Nome accessibile; senza, l'icona è decorativa perché accanto c'è il nome dell'App. */
  readonly label = input<string | null>(null);

  protected readonly letter = computed(() => this.code().charAt(0).toUpperCase());
  protected readonly px = computed(() => SIZES[this.size()].px);
  protected readonly boxClass = computed(
    () =>
      `inline-flex overflow-hidden ${SIZES[this.size()].box} ${
        this.muted() ? 'bg-stone-100 dark:bg-stone-800' : 'bg-bsite-400'
      }`,
  );
  protected readonly glyphClass = computed(() =>
    this.muted() ? 'fill-stone-500 dark:fill-stone-300' : 'fill-ink',
  );
}
